import { SizeNames } from './constants';
export var getButtonTextStyles = function getButtonTextStyles(size) {
  switch (SizeNames[size]) {
    case 'Small':
      return 'ButtonSmallTitle';

    case 'Medium':
      return 'ButtonMediumTitle';

    case 'Large':
      return 'ButtonLargeTitle';
    // TODO (lindsey-menges): deprecate XLarge size in v7

    case 'XLarge':
      return 'ButtonLargeTitle';

    default:
      return 'ButtonMediumTitle';
  }
};
export var getColorSemantic = function getColorSemantic(_ref) {
  var isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      kind = _ref.kind,
      section = _ref.section,
      state = _ref.state;

  if (isDisabled) {
    return isSelected ? "Button".concat(kind, "ToggleGroup").concat(section, "OnDisabled") : "Button".concat(kind, "ToggleGroup").concat(section, "OffDisabled");
  }

  return isSelected ? "Button".concat(kind, "ToggleGroup").concat(section, "On").concat(state || '') : "Button".concat(kind, "ToggleGroup").concat(section, "Off").concat(state || '');
};